(window as any).APP_VERSION = APP_VERSION;

export {};